import { useEffect } from 'react'

import { useLocalStorage } from '@nx/hooks/use-local-storage'

import { useMigrateRecentlyViewedLots } from './useMigrateRecentlyViewedLots'

interface UseRecentlyViewedLotsProps {
  lotId: number
}

const MAX_RECENTLY_VIEWED_LOTS = 8

export function useAddRecentlyViewedLots({
  lotId,
}: UseRecentlyViewedLotsProps) {
  // When user visits lot it gets added to localStorage recently viewed list to be used in the Web App
  // then also gets stored in a cookie for the Cars App as localStorage cannot be shared between subdomains

  const [recentlyViewedLotIds, setRecentlyViewedLotIds] = useLocalStorage<
    number[]
  >('recentlyViewedLotIds', [])

  useMigrateRecentlyViewedLots(recentlyViewedLotIds, setRecentlyViewedLotIds)

  useEffect(() => {
    const lotInLocalStoragePosition = recentlyViewedLotIds.findIndex(
      (recentLotId) => recentLotId === lotId
    )

    if (lotInLocalStoragePosition > -1) {
      recentlyViewedLotIds.splice(lotInLocalStoragePosition, 1)
    } else if (recentlyViewedLotIds.length >= MAX_RECENTLY_VIEWED_LOTS) {
      recentlyViewedLotIds.pop()
    }

    recentlyViewedLotIds.unshift(lotId)
    setRecentlyViewedLotIds(recentlyViewedLotIds)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lotId])
}
